<template>
  <div class="c-theUserNav">
    <div
      class="c-theUserNav_inner"
      ref="inner"
    >
      <div
        class="c-theUserNav_notActiveArea"
        :class="{ 'c-theUserNav_notActiveArea-noMenu': !isVisibleWholeMenu() }"
        v-if="!isEditable && $util.isBeforePeriodDate(user.lastLoginedAt, 180)"
      >
        <div class="c-theUserNav_notActive">
          <CoconalaIcon
            name="exclamation-circle"
            class="c-theUserNav_notActiveIcon"
          />
          この出品者は半年以上ログインしていません。購入後、出品者から48時間以内に連絡がなかった取引は自動キャンセルされます。
        </div>
      </div>
      <div
        class="c-theUserNav_notActiveArea"
        v-else-if="!isEditable && $util.isBeforePeriodDate(user.lastLoginedAt, 30)"
      >
        <div class="c-theUserNav_notActive">
          <CoconalaIcon
            name="exclamation-circle"
            class="c-theUserNav_notActiveIcon"
          />
          この出品者は30日以上ログインしていません。購入後、出品者から48時間以内に連絡がなかった取引は自動キャンセルされます。
        </div>
      </div>
      <ul
        class="c-theUserNav_menu"
        v-if="isVisibleWholeMenu()"
      >
        <li
          class="c-theUserNav_menuItem"
          v-for="page in pages"
          v-if="isVisibleMenu(page.slug)"
          :key="page.slug"
          :class="itemClass(page.slug)"
        >
          <nuxt-link
            :to="genUserPath(page.slug)"
            v-if="page.isReady"
          >
            {{ page.text }}
          </nuxt-link>
          <b-tooltip
            label="Coming soon!"
            position="is-bottom"
            style="display: block;"
            v-if="!page.isReady"
          >
            <a href="javascript:;">{{ page.text }}</a>
          </b-tooltip>
        </li>
      </ul>
      <slot />
    </div>
    <hr class="c-theUserNav_bottomBorder" />
  </div>
</template>
<script>
import { mapState, mapGetters } from 'vuex'

const HOME = 'home'
const REVIEWS = 'reviews'
const CAREERS = 'careers'
const PORTFOLIOS = 'portfolios'
const PRICES = 'prices'
const SERVICES = 'services'
const BLOG = 'blogs'

const visibilityControlTargets = [REVIEWS, CAREERS, PRICES, SERVICES, PORTFOLIOS, BLOG]

export const PAGES = [
  {
    slug: HOME,
    text: 'ホーム',
    isReady: true
  },
  {
    slug: REVIEWS,
    text: '実績/評価',
    isReady: true
  },
  {
    slug: CAREERS,
    text: 'スキル/経歴',
    isReady: true
  },
  {
    slug: PORTFOLIOS,
    text: 'ポートフォリオ',
    isReady: true
  },
  {
    slug: PRICES,
    text: '料金プラン',
    isReady: true
  },
  {
    slug: SERVICES,
    text: '出品サービス',
    isReady: true
  },
  {
    slug: BLOG,
    text: 'ブログ',
    isReady: true
  }
]

export default {
  name: 'TheUserNav',
  props: {
    slug: {
      type: String,
      default: 'home'
    },
    isEditable: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    itemClass(slug) {
      return { '-is-current': slug === this.slug, [`-${slug}`]: true }
    },
    genUserPath(slug) {
      if (slug === BLOG) {
        return this.isEditing ? '/mypage/blogs' : `/blogs/${this.userId}`
      }
      let basePath = this.isEditing ? '/mypage/user' : `/users/${this.userId}`
      return slug !== 'home' ? `${basePath}/${slug}` : basePath
    },
    isVisibleWholeMenu() {
      return (
        this.pages.filter(
          p => visibilityControlTargets.includes(p.slug) && this.isVisibleMenu(p.slug)
        ).length > 0
      )
    },
    isVisibleMenu(slug) {
      if (this.isEditable) {
        // ブログの場合、PC以外の編集機能がないため表示しない
        if (slug === BLOG && !this.isPC) {
          return false
        }
        return true
      }

      if (slug === REVIEWS && !this.hasInfo.hasRating) {
        return false
      }
      if (
        slug === CAREERS &&
        !this.hasInfo.hasSpecialty &&
        !this.hasInfo.hasSkill &&
        !this.hasInfo.hasLicense &&
        !this.hasInfo.hasCareer &&
        !this.hasInfo.hasAward
      ) {
        return false
      }
      if (slug === PORTFOLIOS && !this.hasInfo.hasPortfolio) {
        return false
      }
      if (slug === PRICES && !this.hasInfo.hasPrice) {
        return false
      }
      if (slug === SERVICES && !this.hasInfo.hasService) {
        return false
      }
      if (slug === BLOG && !this.hasInfo.hasBlog) {
        return false
      }

      return true
    }
  },
  computed: {
    ...mapState('pages/users', ['user']),
    ...mapGetters('pages/users', ['isOwner', 'isEditing']),
    ...mapGetters('ui', ['isPC']),
    hasInfo() {
      if (this.isEditable) {
        return this.$store.state.pages.users.my.user.hasInfo
      }
      return this.$store.state.pages.users.user.hasInfo
    },
    pages() {
      return PAGES
    },
    userId() {
      return Number(this.$route.params.id)
    }
  }
}
</script>
<style lang="scss" scoped>
.c-theUserNav {
  &_inner {
    width: 100%;
  }
  &_bottomBorder {
    margin: -1px 0 0 0;
    height: 1px;
    border-bottom: 1px solid $color-border-base;
  }
  &_notActiveArea {
    padding: 16px 12px 4px;
    background-color: $ds2-color-white;

    &-noMenu {
      padding: 16px 12px;
    }
  }
  &_notActive {
    display: flex;
    margin: 0 auto;
    padding: 8px;
    max-width: 1040px;
    width: 100%;
    border-radius: 4px;
    background-color: $ds2-color-red-50;
    color: $ds2-color-gray-900;
    font-size: 13px;
    line-height: 1.5;
  }
  &_notActiveIcon {
    margin: 1px 4px 0 0;
    color: $ds2-color-red;
    font-size: 16px;
  }
  &_menu {
    display: flex;
    width: 100%;
    background-color: $color-bg-primary;

    justify-content: center;
  }
  &_menuItem {
    a {
      @include link-effect;

      display: block;
      padding: 8px 20px;
      height: 100%;
      color: $color-font-base;
      text-align: center;
      white-space: nowrap;
      font-size: 16px;
    }
    &.-is-current {
      a {
        color: $color-font-base;
        font-weight: bold;
        &::after {
          display: block;
          margin: 2px auto 0;
          width: 40%;
          height: 4px;
          border-radius: 5px;
          background-color: $color-app-primary;
          content: '';
        }
      }
    }
  }

  @media (max-width: $breakpoint-l) {
    &_menuItem {
      a {
        padding: 6px 10px;
        font-size: 14px;
      }
    }
  }

  @media (max-width: $breakpoint-m) {
    &_notActiveArea {
      display: none;
    }
    &_menu {
      border-top: 1px solid $color-border-base;

      flex-wrap: wrap;
      justify-content: flex-start;
    }
    &_menuItem {
      flex: 1 0 33.3%;
      max-width: 33.3%;
      border-right: 1px solid $color-border-base;
      border-bottom: 1px solid $color-border-base;
      a {
        padding: 8px 5px;
        min-width: 70px;
        color: $color-font-base;
        font-size: 14px;
      }
      &.-is-current {
        a {
          background-color: $color-bg-base;
          color: $color-link-base;
          &::after {
            display: none;
          }
        }
      }
    }
  }

  @media (max-width: $breakpoint-s) {
    &_menuItem {
      a {
        font-size: 12px;
      }
    }
  }
}
</style>
